module.exports = __webpack_public_path__ + "img/img-1-1000x600.c993e3af.jpg";